import './LoadingState.css';

/**
 * Reusable loading state component
 * @param {string} message - Custom loading message (optional)
 * @param {string} className - Additional CSS class (optional)
 */
function LoadingState({ message = 'Caricamento...', className = '' }) {
  return (
    <div className={`loading-state ${className}`}>
      <div className="loading-spinner">
        <i className="fa-solid fa-spinner fa-spin"></i>
      </div>
      <p className="loading-message">{message}</p>
    </div>
  );
}

export default LoadingState;
